import React from 'react'
import { Col, Container, Row } from 'react-bootstrap'
import '../pages/Disclaimer.css'

function Disclaimer() {
    return (
        <Container fluid className='disclaimerContainer'>
            <Row className='justify-content-center'>
                <Col md={12} className='text-center'>
                    <h3 className='mt-5 sectionHeading'>
                        Disclaimer
                    </h3>
                </Col>
            </Row>

            <Row className='justify-content-center mt-4'>
                <Col md={10} className='disclaimerText'>
                    <p>
                        The information contained on this website is provided for general informational purposes
                        only and should not be construed as legal advice, professional advice, or a substitute for
                        consultation with qualified legal professionals.
                    </p>
                    <p>
                        REAA acts as a platform and institution facilitating arbitration, mediation, conciliation,
                        and other alternative dispute resolution processes in accordance with applicable laws, rules,
                        and agreed procedures. The content available on this website is intended solely to provide an
                        overview of our services and processes. While every effort is made to ensure the accuracy
                        and timeliness of the information published on this website, REAA makes no representations
                        or warranties, express or implied, regarding the completeness, accuracy, reliability, or
                        suitability of such information. Users are advised to independently verify any information
                        before relying upon it.
                    </p>
                    <p>
                        Submission of an enquiry, registration, communication through the website, email, WhatsApp,
                        SMS, or participation in any proceeding does not create an advocate-client relationship or
                        constitute legal representation by REAA.
                    </p>
                    <p>
                        The outcome of any arbitration, mediation, conciliation, or dispute resolution proceeding
                        depends upon the facts, evidence, applicable law, and the merits of each individual case.
                        Accordingly, REAA does not guarantee any particular result, award, settlement, recovery, or
                        resolution.
                    </p>
                    <p className='mb-0'>
                        Users are responsible for ensuring that the information and documents submitted by them are
                        accurate, complete, and lawful. REAA shall not be liable for any loss, damage, or
                        consequences arising from reliance on the information available on this website or from the
                        use of its services, except as required by applicable law. By accessing and using this
                        website, users acknowledge and agree to the terms of this Disclaimer.
                    </p>
                </Col>
            </Row>
        </Container>
    )
}

export default Disclaimer
